// Abonnemangsnivå för inloggat konto: free (provperiod) | bas | pro | enterprise.
import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { fetchFreeTierState } from "@/lib/plan/freeTier";

export type PlanTier = "free" | "bas" | "pro" | "enterprise";

export const PLAN_LABELS: Record<PlanTier, string> = {
  free: "Provperiod",
  bas: "Bas",
  pro: "Pro",
  enterprise: "Enterprise",
};

const ORDER: PlanTier[] = ["bas", "pro", "enterprise"];

export const tierAtLeast = (tier: PlanTier, required: PlanTier): boolean =>
  ORDER.indexOf(tier) >= ORDER.indexOf(required);

export const usePlanTier = () => {
  const [tier, setTier] = useState<PlanTier>("bas");
  const [trialActive, setTrialActive] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase.rpc("get_plan_tier");
      const value = !error && typeof data === "string" ? (data as PlanTier) : "bas";
      if (value === "free") {
        const free = await fetchFreeTierState();
        setTier("free");
        setTrialActive(Boolean(free && !free.expired));
      } else {
        setTier(ORDER.includes(value) ? value : "bas");
        setTrialActive(false);
      }
    } catch {
      setTier("bas");
      setTrialActive(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return {
    tier,
    trialActive,
    loading,
    reload: load,
    /**
     * Provperioden öppnar hela systemet – annars gäller nivåordningen.
     */
    hasTier: (required: PlanTier) =>
      tier === "free" ? trialActive : tierAtLeast(tier, required),
  };
};
